import { AddProductsToCartButton, AddProductsToCartError, ProductCustomizable, ProductPagePrice, ProductPagePriceTiers } from "@graphcommerce/magento-product";
import { ConfigurableContextProvider, ConfigurableName, ConfigurablePrice, ConfigurablePriceTiers } from "@graphcommerce/magento-product-configurable";
import { isTypename } from "@graphcommerce/next-ui";
import { Box, Divider, Link, Typography } from "@mui/material";
import { Trans } from "@lingui/react";
import { Money } from "@graphcommerce/magento-store";
import { ProductShortDescription } from "../Product/ProductShortDescription";
import { ProductReviewChip } from "../Reviews/ProductReviewChip";
import Sidebar from "./Sidebar";
import { ConfigurableProductOptions } from "./ConfigurableProductOptions";
import { BundleProductOptions } from "@graphcommerce/magento-product-bundle";
import { DownloadableProductOptions } from "@graphcommerce/magento-product-downloadable";
import { AdjustedProductSidebarDelivery } from "./AdjustedProductSidebarDelivery";
import { ProductWishlistChipDetail } from "@graphcommerce/magento-wishlist";
import CustomizeButtonDirect from "../CustomizeButton/CustomizeButtonDirect";
import { Usps } from "components/Usps/Usps";
import { AddProductsToCartQuantity } from "../Input/AddProductsToCartQuantity";

export default function ConfigurableAddAndCustomize(props: any) {
  const {
    product,
    currentTypeProduct,
    currentSku,
    sidebar,
    setDisableButton,
    qtyEngaged,
    update,
    addAndCustomize,
    disableButton,
    SkuData,
    tetherList,
    by_use_id,
    sidebarUsps,
  } = props;

  return (
    <>
      <ConfigurableContextProvider {...currentTypeProduct} sku={currentSku}>
        <div>
          {isTypename(product, ['ConfigurableProduct', 'BundleProduct']) && (
            <Typography component='div' variant='body2' color='text.disabled'>
              <Trans
                id='As low as <0/>'
                components={{ 0: <Money {...product.price_range.minimum_price.final_price} /> }}
              />
            </Typography>
          )}

          <Typography variant='h2' component='h1' gutterBottom>
            <ConfigurableName product={product} />
          </Typography>

          <ProductShortDescription
            short_description={product?.description}
            sx={(theme) => ({ mb: theme.spacings.xs })}
          />

          <ProductReviewChip review_count={product?.review_count} rating={product.rating_summary} reviewSectionId='reviews' />

          {sidebar && <Sidebar sidebar={sidebar} />}
        </div>

        {isTypename(product, ['ConfigurableProduct']) && (

          <ConfigurableProductOptions
            product={product}
            currentSku={currentSku}
            setDisableButton={setDisableButton}
            optionEndLabels={{
              size: (
                <Link
                  href='/modal/product/global/size'
                  rel='nofollow'
                  color='primary'
                  underline='hover'
                >
                  <Trans id='Which size is right?' />
                </Link>
              ),
            }}
          />
        )}
        {isTypename(product, ['BundleProduct']) && (
          <BundleProductOptions product={product} layout='stack' />
        )}
        {isTypename(product, ['DownloadableProduct']) && (
          <DownloadableProductOptions product={product} />
        )}
        {!isTypename(product, ['GroupedProduct']) && <ProductCustomizable product={product} />}

        <Divider />

        {qtyEngaged && <Box
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            columnGap: theme.spacings.md,
          })}
        >
          <AddProductsToCartQuantity sx={{ flexShrink: '0' }} />

          <AddProductsToCartError>
            <Typography component='div' variant='h3' lineHeight='1'>
              {isTypename(product, ['ConfigurableProduct']) ? (
                <ConfigurablePrice product={product} />
              ) : (
                <ProductPagePrice product={product} />
              )}
            </Typography>
          </AddProductsToCartError>
        </Box>}

        {isTypename(product, ['ConfigurableProduct']) ? (
          <ConfigurablePriceTiers product={product} />
        ) : (
          <ProductPagePriceTiers product={product} />
        )}

        <AdjustedProductSidebarDelivery product={product} />

        <Box
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'start',
            columnGap: theme.spacings.xs,
          })}
        >
          <AddProductsToCartButton fullWidth product={product} />
          <ProductWishlistChipDetail {...product} />
        </Box>

        {update === true &&
          <>
            {addAndCustomize &&
              <>
                {isTypename(product, ['ConfigurableProduct']) && (
                  <>
                    {!disableButton && <CustomizeButtonDirect SkuOrganizer={SkuData.data.pages[0].content} tetherList={tetherList} by_use_id={by_use_id} currentSku={currentSku} product={product} sx={(theme) => ({
                      zIndex: theme.zIndex.appBar - 1,
                      marginTop: theme.spacings.sm,
                      marginBottom: theme.spacings.sm,
                      width: '100%',
                      display: 'flex',
                      marginX: 'auto',
                      position: 'sticky',
                      bottom: 20,
                      top: 20,
                    })} />}
                    {disableButton && <CustomizeButtonDirect SkuOrganizer={SkuData.data.pages[0].content} by_use_id={by_use_id} currentSku={currentSku} product={product} tetherList={tetherList} disabled sx={(theme) => ({
                      marginTop: theme.spacings.sm,
                      marginBottom: theme.spacings.sm,
                      width: '100%',
                      display: 'flex'
                    })} />}
                  </>
                )}
              </>
            }
          </>
        }
        {update === false &&
          <>
            {addAndCustomize &&
              <>
                {isTypename(product, ['ConfigurableProduct']) && (
                  <>
                    {!disableButton && <CustomizeButtonDirect SkuOrganizer={SkuData.data.pages[0].content} tetherList={tetherList} by_use_id={by_use_id} currentSku={currentSku} product={product} sx={(theme) => ({
                      zIndex: theme.zIndex.appBar - 1,
                      marginTop: theme.spacings.sm,
                      marginBottom: theme.spacings.sm,
                      width: '100%',
                      display: 'flex',
                      marginX: 'auto',
                      position: 'sticky',
                      bottom: 20,
                      top: 20,
                    })} />}
                    {disableButton && <CustomizeButtonDirect SkuOrganizer={SkuData.data.pages[0].content} by_use_id={by_use_id} currentSku={currentSku} product={product} tetherList={tetherList} disabled sx={(theme) => ({
                      marginTop: theme.spacings.sm,
                      marginBottom: theme.spacings.sm,
                      width: '100%',
                      display: 'flex'
                    })} />}
                  </>
                )}
              </>
            }
          </>
        }

        <Usps usps={sidebarUsps} size='small' />
      </ConfigurableContextProvider>

    </>
  )
}